import React from "react";
import { useNavigate } from "react-router-dom";
import { App } from "./Constants";
import { ReactComponent as HealthbeaconContactDetails } from "../assets/images/Healthbeacon-contact-details-black.svg";
import BlobLoader from "../components/common/Loader/BlobLoader";

const primaryButtonClass =
  "inline-flex h-[46px] min-w-[160px] cursor-pointer items-center justify-center rounded-full border-0 bg-[#00567a] px-6 text-lg font-bold leading-[22px] text-white hover:bg-[#005eb8]";

const secondaryButtonClass =
  "inline-flex h-[46px] min-w-[160px] cursor-pointer items-center justify-center rounded-full border-2 border-[#00567a] bg-white px-6 text-lg font-bold leading-[22px] text-[#00567a] hover:bg-[#f0f7fa]";

const PageNotFound = () => {
  const navigate = useNavigate();

  return (
    <div
      data-testid="notfound-page"
      className="flex flex-1 flex-col"
    >
      <main className="flex flex-1 flex-col items-center justify-center px-4 py-16">
        <div
          data-testid="notfound-visual-icon"
          className="mb-8 flex justify-center"
        >
          <BlobLoader showLoadingText={false} size={180} />
        </div>

        <h1
          data-testid="notfound-error-heading"
          className="mb-4 max-w-xl text-center text-3xl font-bold text-[#00567a] sm:text-4xl"
        >
          Sorry this page is not available
        </h1>

        <p
          data-testid="notfound-error-description"
          className="mb-10 max-w-md text-center text-base text-[#505050]"
        >
          This is probably due to the selection of an old link
        </p>

        <div className="flex flex-wrap items-center justify-center gap-4">
          <button
            type="button"
            data-testid="notfound-navigation-home-button"
            className={primaryButtonClass}
            onClick={() => navigate(App.DASHBOARD)}
          >
            Go to home
          </button>
          <button
            type="button"
            data-testid="notfound-navigation-contact-button"
            className={secondaryButtonClass}
            onClick={() => navigate(App.CONTACT_US)}
          >
            Contact us
          </button>
        </div>
      </main>

      <footer
        data-testid="notfound-footer-support-info"
        className="mt-auto flex justify-center px-6 pb-10 pt-4"
      >
        <HealthbeaconContactDetails
          className="h-auto w-full max-w-xl select-none sm:max-w-xl"
          role="img"
          aria-label="HealthBeacon — Smart Tools for Managing Medication. For support, contact Pharmacare Group."
        />
      </footer>
    </div>
  );
};

export default PageNotFound;
